/** Fecha de pago a proveedor: hoy o días con cierre abierto (Casa central). */

export function toLocalYmd(d: Date): string {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function isFechaPagoCajaPermitida(
  ymd: string,
  fechasDisponibles: string[],
): boolean {
  return Boolean(ymd) && fechasDisponibles.includes(ymd);
}

/** Día del calendario sin cierre abierto (o sin próxima caja). */
export function isCalendarDayCajaCerrada(
  date: Date,
  fechasDisponibles: string[],
): boolean {
  return !fechasDisponibles.includes(toLocalYmd(date));
}

export function resolveFechaPagoDefault(
  fechas: string[],
  defaultFecha: string | null | undefined,
  todayYmd: string,
): string {
  if (defaultFecha && fechas.includes(defaultFecha)) return defaultFecha;
  if (fechas.includes(todayYmd)) return todayYmd;
  return fechas[0] || todayYmd;
}

/**
 * Modal «hoy cerrado → próxima caja»: solo si la fecha elegida es posterior a hoy.
 * Una fecha abierta anterior no debe avisar «día siguiente».
 */
export function hoyCerradoUsaProximaCaja(
  fechasDisponibles: string[],
  fechaPago: string,
  todayYmd: string,
): boolean {
  return (
    !fechasDisponibles.includes(todayYmd) &&
    Boolean(fechaPago) &&
    fechaPago !== todayYmd &&
    fechaPago > todayYmd
  );
}
